import Text from "@jnctn/design-system/Text/Text.component";
import useDocumentTitle from "@jnctn/hooks/useDocumentTitle";
import buildDocumentTitle from "@jnctn/webcore/ui-helpers/buildDocumentTitle";
import FlexLayoutItem, {
  layouts,
} from "@jnctn/design-system/Flexbox/FlexLayoutItem.component";
import { useBack } from "@jnctn-app/contexts/BackContext";
import { useAuthContext } from "../../contexts/AuthContextProvider";
import StandardButton from "@jnctn/design-system/Button/StandardButton.component";
import { ReactComponent as LogoutIcon } from "@jnctn/icons/logout.svg";
import Button from "@jnctn/design-system/Button/Button.component";
import { ReactComponent as ReportIssueIcon } from "@jnctn/icons/report-issue.svg";
import { Checksum } from "@jnctn/api/app/fetchChecksums";
import TenantPicker from "@jnctn-app/core/components/TenantPicker.component";

export function TenantErrorPageNoTenants() {
  useDocumentTitle(buildDocumentTitle(["JNCTN", "Account Inactive"]));
  useBack(undefined);
  const { onSignOut } = useAuthContext();

  return (
    <FlexLayoutItem grow={1} layout={layouts.verticalStretch} className="p-10">
      <FlexLayoutItem
        grow={1}
        align="center"
        layout={layouts.verticalCenterAll}
        className="space-y-6 max-w-lg"
      >
        <Text size="header1" color="primary">
          Your account doesn't belong to any tenants.
        </Text>
        <Text size="body1" color="primary" textAlign="center">
          To ensure your account is activated please contact the administrator
          of your organization.
        </Text>
        <StandardButton
          label="Sign Out"
          icon={<LogoutIcon />}
          onClick={onSignOut}
        />
      </FlexLayoutItem>
      <FlexLayoutItem align="center">
        <a
          href="https://help.jnctn.nz/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
          className="flex"
        >
          <Button
            label="Report an Issue"
            icon={<ReportIssueIcon className="mr-4 w-8 h-8" />}
            className="justify-start inline-flex items-center font-semibold font-body text-charcoal-800"
          />
        </a>
      </FlexLayoutItem>
    </FlexLayoutItem>
  );
}

export function TenantErrorPageNoActiveTenants() {
  useDocumentTitle(buildDocumentTitle(["JNCTN", "Account Inactive"]));
  useBack(undefined);
  const { onSignOut } = useAuthContext();

  return (
    <FlexLayoutItem grow={1} layout={layouts.verticalStretch} className="p-10">
      <FlexLayoutItem
        grow={1}
        align="center"
        layout={layouts.verticalCenterAll}
        className="space-y-6 max-w-lg"
      >
        <Text size="header1" color="primary" textAlign="center">
          Your account isn't active in any tenant you belong to.
        </Text>
        <Text size="body1" color="primary" textAlign="center">
          To ensure your account is activated please contact the administrator
          of your organization.
        </Text>
        <StandardButton
          label="Sign Out"
          icon={<LogoutIcon />}
          onClick={onSignOut}
        />
      </FlexLayoutItem>
      <FlexLayoutItem align="center">
        <a
          href="https://help.jnctn.nz/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
          className="flex"
        >
          <Button
            label="Report an Issue"
            icon={<ReportIssueIcon className="mr-4 w-8 h-8" />}
            className="justify-start inline-flex items-center font-semibold font-body text-charcoal-800"
          />
        </a>
      </FlexLayoutItem>
    </FlexLayoutItem>
  );
}

export function TenantErrorPageInactive({ checksum }: { checksum: Checksum }) {
  useDocumentTitle(buildDocumentTitle(["JNCTN", "Account Inactive"]));
  useBack(undefined);
  const { onSignOut } = useAuthContext();

  return (
    <FlexLayoutItem grow={1} layout={layouts.verticalStretch} className="p-10">
      <FlexLayoutItem
        grow={1}
        align="center"
        layout={layouts.verticalCenterAll}
        className="space-y-6 max-w-lg"
      >
        <Text size="header1" color="primary" textAlign="center">
          Your account isn't active in the selected tenant.
        </Text>
        <Text size="body1" color="primary" textAlign="center">
          To ensure your account is activated please contact the administrator
          of your organization {checksum.clientName}.
        </Text>
        <TenantPicker label="Change to another tenant" />
        <StandardButton
          label="Sign Out"
          icon={<LogoutIcon />}
          onClick={onSignOut}
        />
      </FlexLayoutItem>
      <FlexLayoutItem align="center">
        <a
          href="https://help.jnctn.nz/hc/en-us/requests/new"
          target="_blank"
          rel="noopener noreferrer"
          className="flex"
        >
          <Button
            label="Report an Issue"
            icon={<ReportIssueIcon className="mr-4 w-8 h-8" />}
            className="justify-start inline-flex items-center font-semibold font-body text-charcoal-800"
          />
        </a>
      </FlexLayoutItem>
    </FlexLayoutItem>
  );
}
